<div class="market-banner"><img src="https://royall444.com/api/users/images/slider-default-2025815182455745.jpg" alt="Universe Casino" style="width: 100%; max-height: 250px; object-fit: cover;"></div>

<!-- If it is Lottery (ID: 66104) -->
<div class="lottery-container" *ngIf="sportId === '66104'">
  <div class="lottery-grid">
    <div class="lottery-item" *ngFor="let game of lotteryGames">
      <div class="lottery-img-placeholder">
        <i class="fas fa-coins golden-coins"></i>
        <div class="matka-text">LOTTERY<br/>MATKA</div>
      </div>
      <div class="game-name">{{ game.name }}</div>
    </div>
  </div>
</div>

<!-- If it is Soccer (ID: 1) or Tennis (ID: 2) etc -->
<div class="sports-container" *ngIf="sportId !== '66104'">
  <div class="sports-header">
    Sport Matches Loading...
  </div>
  <p class="sports-message">Real-time match odds for sport ID {{ sportId }} will be populated here.</p>
</div>
